import * as React from 'react';
import { Order } from '../BookingsCalendarTypes';
import filterOrders from './filterOrders';

type useFilterOrdersProps = {
    orders?: Order[];
    filteredOrders: Order[];
    searchQuery: string;
    selectedRegion: string;
    handleChangeRegionFilter: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    handleChangeSearchQuery: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

function useFilterOrders(orders): useFilterOrdersProps {
    const [searchQuery, setSearchQuery] = React.useState<string>('');
    const [selectedRegion, setSelectedRegion] = React.useState<string>('');

    const handleChangeRegionFilter = React.useCallback(
        (event: React.ChangeEvent<HTMLSelectElement>) => {
            setSelectedRegion(event.target.value);
        },
        []
    );

    const handleChangeSearchQuery = React.useCallback(
        (event: React.ChangeEvent<HTMLSelectElement>) => {
            setSearchQuery(event.target.value);
        },
        []
    );

    const filteredOrders: Order[] = filterOrders(orders, searchQuery, selectedRegion);

    return {
        filteredOrders,
        searchQuery,
        selectedRegion,
        handleChangeRegionFilter,
        handleChangeSearchQuery
    };
}

export default useFilterOrders;
